import React from 'react';
import {  MD, SM  } from '@zendeskgarden/react-typography';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import { map, get } from 'lodash';
import {ProductsSectionHeader, Attribute} from 'routes/Products/Products.styles.js'


const ProductSpecs = ({productDetails}) => {
  const {
    listing_data
  } = productDetails

  const attributes = map(get(listing_data, 'specs'), (d,k) => {
    return {
      title: k, 
      value: d
    }
  })

  return (
    <div style={{minWidth: '100%', maxWidth: '100%'}}>
      <Grid>
        <Row>
          <Col>
            <ProductsSectionHeader tag="h2" style={{fontSize: '26px', marginBottom: '20px'}} paddingBottomMd scaled bold>Equipment Specs</ProductsSectionHeader>
          </Col>
        </Row>

        <Row>
          <Col>
          {
            map(attributes, (attribute, i) => {
              return (
                <Attribute key={i}>
                <MD className="attribute" as="div" light>{attribute.value || '--'}</MD>
                </Attribute>
              )
            })
          }
          </Col>
        </Row>

        <Row>
          <Col style={{marginTop: '30px', borderTop: '1px solid rgb(236 236 236)'}}>
            <SM style={{paddingTop: '30px'}}><SM as="span" style={{}} bold>Disclaimer:</SM> The information on this page is meant to be an overview, check with the OEM for complete accurate specifications and features.</SM>
          </Col>
        </Row>
      
      
      </Grid>
    </div>
  )
}


export default ProductSpecs;
